import { apiService } from "@/api";
import { SubscriptionService } from "./SubscriptionService";
import UserService from "./UserService";
import { PaymentService } from "./PaymentService";
import { SessionService } from "./SessionService";

export const sessionService = new SessionService();
export const subsService = new SubscriptionService(apiService);
export const userService = new UserService(apiService);
export const paymentService = new PaymentService(apiService, sessionService);
